export default "__VITE_ASSET__CNpwD4yE__"